import { render, staticRenderFns } from "./LGSXXLarge.vue?vue&type=template&id=67b20094"
import script from "./LGSXXLarge.vue?vue&type=script&lang=js"
export * from "./LGSXXLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports